import { createRequest } from '@flypower/shared';
import { loginPath } from '../constants/paths';

// 创建请求实例（Host 应用 - 完整功能）
const { 
  request, 
  apiRequest, 
  TokenManager,
  performTokenRefreshAttempt, // Host 需要为子应用提供刷新方法
} = createRequest({
  baseURL: '',
  timeout: 30000,
  loginPath,
  enableTokenExpiration: true,  // 启用 Token 过期管理
  enable402Redirect: true,      // 启用 402 重定向到店铺授权页面
  shopAuthorizationPath: '/authorization/shop-authorization',
  supportExternalRefresh: false, // Host 不需要外部刷新
});

// 导出 TokenManager、apiRequest 和 performTokenRefreshAttempt
export { TokenManager, apiRequest, performTokenRefreshAttempt };

// 导出类型
export type { ApiResponse } from '@flypower/shared';

// 默认导出 axios 实例
export default request;
